import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-modal-search-map',
  templateUrl: './modal-search-map.component.html',
  styleUrls: ['./modal-search-map.component.css']
})
export class ModalSearchMapComponent implements OnInit {
  quickSearchString = '';
  formAdvancedSearch = {
    title: '',
    keywords: '',
    coverage: '',
    description: '',
    rights: '',
    source: '',
    categories: '',
    multimedia_type: '',
    author: '',
    publisher: '',
    coordinates: '',
    format: '',
  };
  searchMode = 0;
  modalMode = 'both'

  constructor(public modal: NgbActiveModal, private translocoService: TranslocoService) { }

  ngOnInit(): void {
    if (this.modalMode === 'advanced') {
      this.searchMode = 1;
    }
  }
  changeSearchMode() {
    if (this.searchMode === 1) {
      this.searchMode = 0;
    } else {
      this.searchMode = 1;
    }
  }
  doFilter() {
    if (this.searchMode === 0) {
      this.modal.close({
        msg: 'quick',
        data: this.quickSearchString
      });  
    } else {
      this.modal.close({
        msg: 'advanced',
        data: this.formAdvancedSearch
      });  
    }
  }


      getTypeLabels(type: string) {
        if (type === 'photo') {
          return this.translocoService.translate('common.photo');
        } else if (type === 'audio') {
          return this.translocoService.translate('common.audio');
        } else if (type === 'video') {
          return this.translocoService.translate('common.video');
        } else if (type === 'document') {
          return this.translocoService.translate('common.document');
        }
      }

}
